<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{
                  lang($store,
                    'sap/listings.subscriptions.not_found')
                }}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-card
              class="salary-table mx-auto px-3 mb-2"
              outlined
            >
              <v-row
                v-for="(item, key) in paginatedObject.data"
                :key="key"
                :style="{
                  background: (!!(item.order.is_subscription)?'#0000001a':'white')
                  }"
              >
                <v-col col="4">
                  <div
                    v-if="!paginatedObject.data[key-1] || paginatedObject.data[key-1].order.uuid !== item.order.uuid"
                  >
                    <datetime-alert
                      v-if="item.order.datetime"
                      :datetime="moment(item.order.datetime)"
                      :icon="false"
                    />
                    <v-chip
                      small
                      v-if="item.order.source && item.order.source !== sources.UNSET"
                      class="mr-2 mb-2"
                      outlined
                    >
                      {{ lang($store, `sap/listings.global.filter.sources.${item.order.source}`) }}
                    </v-chip>
                    <v-chip
                      small
                      class="mr-2 mb-2"
                      outlined
                    >
                      {{
                        lang($store,
                          `sap/listings.global.filter.order_base_types.${item.order.order_base_type}`)
                      }}
                    </v-chip>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div style="font-size: 14px">
                            {{ address(item).contact.name }}
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div style="font-size: 14px">
                            {{ address(item).formatted }}
                            ({{
                              lang($store, 'sap/listings.global.filter.premises.' +
                                address(item).premises_type)
                            }})
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div style="font-size: 14px">
                            {{ $t('salary.payments') }}:
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-if="item.order.payments && item.order.payments.length">
                            <ul>
                              <li v-for="payment in item.order.payments"
                                  :key="payment.uuid">
                                {{
                                  moment(payment.datetime, DATETIME_ISO)
                                    .format(DATE_VIEW)
                                }},
                                {{ payment.sum }}
                                &nbsp;({{
                                  lang($store,
                                    `sap/listings.global.filter.payment_types.${payment.type}`)
                                }})
                              </li>
                            </ul>
                          </div>
                          <div v-else>
                            {{ $t('salary.not_found_payments') }}
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </v-col>
                <v-col col="4">
                  <cleaner-line
                    :cleaner="item.cleaner"
                    :rank="true"
                    :phone="false"
                  />
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          {{ $t('salary.estimated_amount') }}: <b>{{ getRecommendedSalary(item) }}</b>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div> ({{ $t('salary.with_numbers_of_cleaners') }}: {{ item.order.cleaners.length }})</div>
                        <div>
                          {{ $t('salary.rate') }}: <b>{{ getRate(item) }}</b>
                        </div>
                        <div
                          v-if="item.order.additional_services.length"
                        >
                          <ul>
                            <li
                              :key="service"
                              v-for="service in item.order.additional_services">
                              {{ lang($store, `sap/additional_services.titles.${service}`) }}
                              <span
                                v-if="item.order.additional_services_info[service + '__count']"
                              >
                          ({{ item.order.additional_services_info[service + '__count'] }})
                        </span>
                              : <b>{{ getRateService(service, item) }}</b>
                            </li>
                          </ul>
                        </div>
                        <div>
                          {{ $t('salary.insurance') }}: <b>-{{ getInsurance(item) }}</b>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                </v-col>
                <v-col col="4">
                  <div
                    class="d-flex flex-row"
                  >
                    <v-text-field
                      style="max-width: 100px;"
                      :value="item.salary_amount"
                      :loading="updatingData[item.salary_identifier]"
                      :label="(item.salary_amount == 0)?getRecommendedSalary(item):lang($store, 'sap/listings.global.filter.hints.sum')"
                      type="number"
                      required
                      autocomplete="off"
                      @change="updateSimpleRequest(item, 'salary_amount')($event)"
                    >

                      <template v-slot:prepend>
                         <span>
                           <v-icon
                             :color="item.salary_is_payed?'green':'gray'"
                             :title="item.salary_is_payed?lang($store, 'sap/listings.global.filter.statuses.payed'):lang($store, 'sap/listings.global.filter.statuses.not_payed')"
                             @click="updateSimpleRequest(item, 'salary_is_payed')(item.salary_is_payed?0:1)"
                           >
                             {{ item.salary_is_payed ? 'mdi-currency-usd' : 'mdi-currency-usd-off' }}
                           </v-icon>
                        </span>
                      </template>
                    </v-text-field>
                    <v-text-field
                      :value="item.salary_amount_note"
                      :loading="updatingData[item.salary_identifier]"
                      :counter="200"
                      maxlength="200"
                      :label="lang($store, 'sap/listings.global.filter.hints.minicomment')"
                      autocomplete="off"
                      @change="updateSimpleRequest(item, 'salary_amount_note')($event)"
                    >
                      <template v-slot:prepend
                                v-if="item.salary_amount == 0">
                         <span>
                           <v-icon
                             @click="item.salary_amount = getRecommendedSalary(item);updateSimpleRequest(item, 'salary_amount')(getRecommendedSalary(item))"
                           >mdi-check</v-icon>
                        </span>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* constants */
import cleanerPrices from '@/api/salary/cleaners/prices';
import { DATE_VIEW, DATETIME_ISO } from '@/constants/dates';
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import salaryCleanerBaseUpdateSimpleProp from '@/mixins/salary/salaryCleanerBaseUpdateSimpleProp';
/* components */
import DatetimeAlert from '@/components/minialerts/DatetimeAlert.vue';
import CleanerLine from '@/components/minialerts/CleanerLine.vue';
import * as sources from '~constants/sources';

export default {
  name: 'TablePaginatedSalaryBase',
  components: {
    DatetimeAlert,
    CleanerLine,
  },
  mixins: [isComponentLoading, salaryCleanerBaseUpdateSimpleProp],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      L: _,
      moment,
      sources,
      DATE_VIEW,
      DATETIME_ISO,
    };
  },
  methods: {
    address(item) {
      return item.order.is_subscription
        ? item.order.subscription.address
        : item.order.address;
    },
    getRate(item) {
      let salary = 0;
      if (item.cleaner.region && cleanerPrices[item.cleaner.region]) {
        let prices = cleanerPrices[item.cleaner.region];
        if (item.cleaner.rank && prices[item.cleaner.rank]) {
          prices = prices[item.cleaner.rank];
          if (this.address(item).premises_type
            && prices.premises_type[this.address(item).premises_type]) {
            prices = prices.premises_type[this.address(item).premises_type];
            if (item.order.order_base_type && prices[item.order.order_base_type]) {
              salary = prices[item.order.order_base_type];
            }
          }
        }
      }

      return salary.toFixed(2);
    },
    getRateService(service, item) {
      let salary = 0;
      if (item.cleaner.region && cleanerPrices[item.cleaner.region]) {
        let prices = cleanerPrices[item.cleaner.region];
        if (item.cleaner.rank && prices[item.cleaner.rank]) {
          prices = prices[item.cleaner.rank];
          if (prices.additional_services[service]) {
            salary = prices.additional_services[service];
            if (item.order.additional_services_info[`${service}__count`]) {
              salary *= item.order.additional_services_info[`${service}__count`];
            }
          }
        }
      }

      return salary.toFixed(2);
    },
    getInsurance(item) {
      let insurance = 0;
      if (item.cleaner.region
        && cleanerPrices[item.cleaner.region]
        && cleanerPrices[item.cleaner.region].insurance
      ) {
        // eslint-disable-next-line prefer-destructuring
        insurance = cleanerPrices[item.cleaner.region].insurance;
      }
      return insurance;
    },
    getRecommendedSalary(item) {
      let salary = 0;
      item.order.additional_services.forEach((service) => {
        salary += parseFloat(this.getRateService(service, item));
      });
      salary += parseFloat(this.getRate(item));
      salary = ((item.order.cleaners.length > 0) ? (salary / item.order.cleaners.length) : salary);
      salary -= this.getInsurance(item);
      return salary.toFixed(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.salary-table {
  .row:not(:last-child) {
    border-bottom: 1px solid;
  }
}
</style>
